<template>
  <div style="background-color: white;min-width: 1600px;">
      <!-- 头部 -->
      <headers></headers>
      <!-- 内容部分开始 -->
      <!-- 中文版 -->
      <div v-if="langluageType != 'en'" class="window_con">
        <div class="window_banner">
            <img src="../assets/propaganda/banner011.png" alt="" class="window_banner_img" style="width: 1600px;">
        </div>
        <div class="yun01">
          <ul class="clearfix">
            <li>
              <a href="./articlework"><img src="../assets/propaganda/yun01_3.jpg"></a>
              <p class="yun_tit">Work主场云</p>
              <p class="yun_text">一体化线上管理，解决资料审核繁琐、信息传递差、项目收费乱、现场执行难等问题，降低综合运营成本。</p>
              <p class="yun_more"><a href="./articlework">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articlepro"><img src="../assets/propaganda/yun01_6.jpg"></a>
              <p class="yun_tit">Project展装云</p>
              <p class="yun_text">针对展装企业，解决传统业务模式中销售流程乱、客户粘性低、财务管控弱等问题，帮助提高综合项目收益。</p>
              <p class="yun_more"><a href="./articlepro">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articlecrm"><img src="../assets/propaganda/yun01_1.jpg"></a>
              <p class="yun_tit">CRM招展云</p>
              <p class="yun_text">招展业务全流程实时线上管理，帮助规范销售流程管理、提升内部信息传递效率、准确掌握销售动态。</p>
              <p class="yun_more"><a href="./articlecrm">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articledesign"><img src="../assets/propaganda/yun01_7.jpg"></a>
              <p class="yun_tit">Design设计云</p>
              <p class="yun_text">设计资源共享的线上平台，通过聚合效益，汇集存量设计资源，实现共享经济，降低企业综合设计成本。</p>
              <p class="yun_more"><a href="./articledesign">了解更多 ></a></p>
            </li>
          </ul>
        </div>
        <div class="yun01">
          <ul class="clearfix">
            <li>
              <a href="./articleguest"><img src="../assets/propaganda/yun01_2.jpg"></a>
              <p class="yun_tit">Guest观众云</p>
              <p class="yun_text">解决传统业务模式中注册登记时间长、人员接触密集、现场体验差、数据管理难等问题。</p>
              <p class="yun_more"><a href="./articleguest">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articlecargo"><img src="../assets/propaganda/yun01_5.jpg"></a>
              <p class="yun_tit">CarGo物流云</p>
              <p class="yun_text">有效优化传统物流中申报体验差、办证时间长、动态信息慢、规范管理难、现场收费乱等问题。</p>
              <p class="yun_more"><a href="./articlecargo">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articlehub"><img src="../assets/propaganda/yun01_4.jpg"></a>
              <p class="yun_tit">Hub场馆云</p>
              <p class="yun_text">解决传统模式中痕迹保存难、时段信息慢、流转效率低、现场执行难等问题，帮助规范销售流程管理。</p>
              <p class="yun_more"><a href="./articlehub">了解更多 ></a></p>
            </li>
            <li>
              <a href="./articleAi"><img src="../assets/propaganda/yun01_8.jpg"></a>
              <p class="yun_tit">A.I.数据云</p>
              <p class="yun_text">基于ExpoSCM全产业链大数据，借助人工智能（A.I.）提供个性化的数据整合、匹配、精准营销、智慧管理。</p>
              <p class="yun_more"><a href="./articleAi">了解更多 ></a></p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 英文版 -->
      <div v-else class="window_con">
        <div class="window_banner">
            <img src="../assets/propaganda/banner01.png" alt="" class="window_banner_img" style="width: 1600px;">
        </div>
        <div class="yun01">
          <ul class="clearfix">
            <li>
              <a href="./articlework"><img src="../assets/propaganda/yun01_3.jpg"></a>
              <p class="yun_tit">ExpoWork</p>
              <p class="yun_text" style="font-size: 14px;">Online cloud system for official service provider</p>
              <p class="yun_more"><a href="./articlework" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articlepro"><img src="../assets/propaganda/yun01_6.jpg"></a>
              <p class="yun_tit">ExpoProject</p>
              <p class="yun_text" style="font-size: 14px;">Online cloud system for booth builder</p>
              <p class="yun_more"><a href="./articlepro" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articlecrm"><img src="../assets/propaganda/yun01_1.jpg"></a>
              <p class="yun_tit">ExpoCRM</p>
              <p class="yun_text" style="font-size: 14px;">Online cloud system for exhibition organizer</p>
              <p class="yun_more"><a href="./articlecrm" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articledesign"><img src="../assets/propaganda/yun01_7.jpg"></a>
              <p class="yun_tit">ExpoDesign</p>
              <p class="yun_text" style="font-size: 14px;">Sharing platform for booth designer</p>
              <p class="yun_more"><a href="./articledesign" style="text-align: left;">more ></a></p>
            </li>
          </ul>
        </div>
        <div class="yun01">
          <ul class="clearfix">
            <li>
              <a href="./articleguest"><img src="../assets/propaganda/yun01_2.jpg"></a>
              <p class="yun_tit">ExpoGuest</p>
              <p class="yun_text" style="font-size: 14px;">waiting</p>
              <p class="yun_more"><a href="./articleguest" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articlecargo"><img src="../assets/propaganda/yun01_5.jpg"></a>
              <p class="yun_tit">ExpoCarGo</p>
              <p class="yun_text" style="font-size: 14px;">Online cloud system for exhibition carrier</p>
              <p class="yun_more"><a href="./articlecargo" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articlehub"><img src="../assets/propaganda/yun01_4.jpg"></a>
              <p class="yun_tit">ExpoHub</p>
              <p class="yun_text" style="font-size: 14px;">Online cloud system for venue operator</p>
              <p class="yun_more"><a href="./articlehub" style="text-align: left;">more ></a></p>
            </li>
            <li>
              <a href="./articleAi"><img src="../assets/propaganda/yun01_8.jpg"></a>
              <p class="yun_tit">ExpoA.I.</p>
              <p class="yun_text" style="font-size: 14px;">For the Future Expo</p>
              <p class="yun_more"><a href="./articleAi" style="text-align: left;">more ></a></p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 内容部分结束 -->

      <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
  </div>
</template>
<style>
.data-class .el-year-table td.today .cell { 
    font-weight: normal;
    color: #606266;
  }
  .data-class .el-year-table td.current .cell { 
    font-weight: normal;
    color: #409EFF !important;
  }
</style>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';
  export default {
    data() {
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
        value6: ''
      }
    },
    components: {
      headers,
      footers,
      contact
    },
    mounted() {
    },
    beforeDestroy () {},
    methods: {},
    computed:{},
  };
</script>



// WEBPACK FOOTER //
// src/page/index.vue